import {
  Form,
  useParams,
  useActionData,
  useNavigation,
} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useEffect, useState } from "react";

import CompanyProfileCard from "../company-profile-card/CompanyProfileCard";
import EditCompanyFields from "../company-profile-edit/EditCompanyFields";
import Loader from "../../../../components/Loader";

import { getAuthToken, getAdminAuthToken } from "../../../../auth/auth";
import { API_BASE_URL } from "../../../../config";

export default function CompanyEditProfile() {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";
  const errorData = useActionData();

  useEffect(() => {
    if (errorData?.success) {
      toast.success("Profile updated successfully!");
    }

    if (errorData?.error) {
      toast.error("There was a problem updating profile.");
    }
  }, [errorData]);

  const [formData, setFormData] = useState({
    company_profile: {
      avatar: "",
      bio: "",
      company_name: "",
      customers: "",
      employee_count: "",
      job_types: [],
      facebook: "",
      last_funding_round: "",
      linkedin: "",
      revenue: "",
      skills: [],
      telegram: "",
      total_funding: "",
      twitter: "",
      website: "",
      youtube: "",
    },
    locations: [],
  });

  useEffect(() => {
    const handleProfile = async () => {
      setIsLoading(true);

      const response = await fetch(`${API_BASE_URL}/companies/${id}/profile`);

      if (!response.ok) {
        throw new Response("Failed to fetch profile", {
          status: response.status,
        });
      }

      const result = await response.json();
      console.log("company results", result);

      const details = result.data;

      setFormData({
        company_profile: {
          avatar: details.company_profile.avatar || "",
          bio: details.company_profile.bio || "",
          company_name: details.company_profile.company_name || "",
          customers: details?.company_profile.customers || "",
          employee_count: details?.company_profile.employee_count || "",
          job_types: details?.company_profile.job_types || [],
          facebook: details?.company_profile.facebook || "",
          last_funding_round: details?.company_profile.last_funding_round || "",
          linkedin: details?.company_profile.linkedin || "",
          revenue: details?.company_profile.revenue || "",
          telegram: details?.company_profile.telegram || "",
          total_funding: details?.company_profile.total_funding || "",
          twitter: details?.company_profile.twitter || "",
          website: details?.company_profile.website || "",
          youtube: details?.company_profile.youtube || "",
          skills: details?.company_profile.selected_skills || [],
        },
        locations: details?.locations,
      });

      setIsLoading(false);
    };

    handleProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      return {
        ...prev,
        company_profile: {
          ...prev.company_profile,
          [name]: value,
        },
      };
    });
  };

  const handleFileChange = (file) => {
    setFormData((prev) => ({
      ...prev,
      company_profile: {
        ...prev.company_profile,
        avatar: file,
      },
    }));
  };

  const handleLocationChange = (updatedLocations) => {
    setFormData((prev) => ({
      ...prev,
      locations: updatedLocations,
    }));
  };

  const handleDeleteLocation = (id) => {
    setFormData((prev) => ({
      ...prev,
      locations: prev.locations.filter((curr) => curr.id !== id),
    }));
  };

  const handleAddLocation = () => {
    const newLocation = {
      id: new Date().getTime(),
      address: "",
      city: "",
      country: "",
      postal_code: "",
      state: "",
    };

    setFormData((prev) => ({
      ...prev,
      locations: [...prev.locations, newLocation],
    }));
  };

  const handleSkillsChange = (selectedSkillsArray) => {
    setFormData((prev) => ({
      ...prev,
      company_profile: {
        ...prev.company_profile,
        skills: selectedSkillsArray,
      },
    }));
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section id="company_edit_page">
        <div className="container">
          {isLoading ? (
            <Loader />
          ) : (
            <Form method="post" encType="multipart/form-data">
              <div className="company-save-btn-wrapper">
                <button
                  type="submit"
                  className="btn-all-white company-edit-btn"
                >
                  {isSubmitting ? "Saving..." : "Save Changes"}
                </button>
                {/* {errorData?.error && (
                  <div className="alert-error">
                    <ul>
                      {Object.entries(errorData.error).map(
                        ([field, messages]) =>
                          messages.map((msg, index) => (
                            <li key={`${field}-${index}`}>
                              <strong>{field}:</strong> {msg}
                            </li>
                          ))
                      )}
                    </ul>
                  </div>
                )} */}
              </div>
              <div className="row-essy">
                <div className="col-essy-md-12 col-essy-lg-6">
                  <EditCompanyFields
                    details={formData}
                    handleFileChange={handleFileChange}
                    handleChange={handleChange}
                    handleDeleteLocation={handleDeleteLocation}
                    handleLocationChange={handleLocationChange}
                    handleAddLocation={handleAddLocation}
                    handleSkillsChange={handleSkillsChange}
                  />
                </div>
                <div className="col-essy-md-12 col-essy-lg-6">
                  <div className="edit-company-profile-card">
                    <CompanyProfileCard details={formData} />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </div>
      </section>
    </>
  );
}

export const editCompanyProfileAction = async ({ request, params }) => {
  const formData = await request.formData();

  const token = getAuthToken() || getAdminAuthToken();
  const userId = params.id;

  const data = new FormData();

  const avatarFile = formData.get("profile_image");

  if (avatarFile instanceof File) {
    data.append("avatar", avatarFile);
  }

  data.append("company_name", formData.get("company_name"));
  data.append("website", formData.get("website"));
  data.append("bio", formData.get("bio"));
  data.append("employee_count", formData.get("employee_count"));
  data.append("total_funding", formData.get("total_funding"));
  data.append("revenue", formData.get("revenue"));
  data.append("last_funding_round", formData.get("last_funding_round"));
  data.append("customers", formData.get("customers"));

  const locationRaw = JSON.parse(formData.get("locations") || "[]");

  const skillsRaw = JSON.parse(formData.get("skills"));

  skillsRaw.forEach((id) => {
    data.append("skills[]", id);
  });

  locationRaw.forEach((loc, index) => {
    data.append(`locations[${index}][country]`, loc.country);
    data.append(`locations[${index}][city]`, loc.city);
    data.append(`locations[${index}][address]`, loc.address);
    data.append(`locations[${index}][state]`, loc.state || "");
    data.append(`locations[${index}][postal_code]`, loc.postal_code || "");
  });

  data.append("linkedin", formData.get("linkedin"));
  data.append("telegram", formData.get("telegram"));
  data.append("facebook", formData.get("facebook"));
  data.append("youtube", formData.get("youtube"));
  data.append("twitter", formData.get("twitter"));

  data.append("company_id", userId);

  // console.log("=== FormData sadržaj ===");
  // for (let [key, value] of data.entries()) {
  //   console.log(key, value);
  // }

  const response = await fetch(`${API_BASE_URL}/company/update-profile`, {
    method: "POST",
    body: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json();

  if (result.success === false) {
    return {
      error: result.errors || "Saving failed. Please try again",
    };
  }

  localStorage.setItem("avatar", result.avatar);
  return { success: true };
};
